// NOTE: This file can't be marked with "client-only" or "server-only" because it's used in both environments.

// Define data sources for DataProvider here
export const DATA_KEYS = {
  availableTimeSlots: 'availableTimeSlots',
  basicPatient: 'basicPatient',
  cartCheckout: 'cartCheckout',
  checkout: 'checkout',
  eligibilityData: 'eligibilityData',
  guardian: 'guardian',
  isAuthenticated: 'isAuthenticated',
  isGetTextsCheckboxChecked: 'isGetTextsCheckboxChecked',
  isPhoneNumberVerificationRequired: 'isPhoneNumberVerificationRequired',
  patient: 'patient',
  photoUploadedData: 'photoUploadedData',
  productSelection: 'productSelection',
  promotion: 'promotion',
  recognizeEmailFlowFlag: 'recognizeEmailFlowFlag',
  resubscriptionCheckoutCombinedData: 'resubscriptionCheckoutCombinedData',
  scheduledConsultation: 'scheduledConsultation',
  session: 'session',
  subscriptions: 'subscriptions',
  userInfo: 'userInfo',
} as const;

export type DataKey = keyof typeof DATA_KEYS;
